var _mask, _rect, _mask2, _rect2, _rect3, _rect4, _rect5, _rect6, _mask3, _rect7, _rect8, _rect9, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNavTrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_191_3355",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 5,
    height: 10,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 5,
    height: 10,
    rx: 1,
    stroke: "#86A1A1",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_191_3355)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_191_3355",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 7,
    width: 5,
    height: 10,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 7,
    width: 5,
    height: 10,
    rx: 1,
    stroke: "#86A1A1",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_191_3355)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5,
    width: 2,
    height: 3,
    rx: 0.5,
    fill: "#86A1A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 16,
    width: 2,
    height: 3,
    rx: 0.5,
    fill: "#86A1A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 5,
    width: 2,
    height: 3,
    rx: 0.5,
    fill: "#86A1A1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 16,
    width: 2,
    height: 3,
    rx: 0.5,
    fill: "#86A1A1"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_191_3355",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 3,
    width: 5,
    height: 10,
    rx: 1
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 3,
    width: 5,
    height: 10,
    rx: 1,
    stroke: "#86A1A1",
    strokeWidth: 4,
    mask: "url(#path-7-inside-3_191_3355)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1,
    width: 2,
    height: 3,
    rx: 0.5,
    fill: "#86A1A1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 2,
    height: 3,
    rx: 0.5,
    fill: "#86A1A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1V21C2.00003 22 2 22 3 22C4.6 22 17.5 22 23 22",
    stroke: "#86A1A1",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavTrade);
export default __webpack_public_path__ + "static/media/ic_nav_trade.3db71bc7ebc3ff62a340e9231af269c3.svg";
export { ForwardRef as ReactComponent };